import React from 'react';
import Image from '../../1_Atoms/Image/Image';
import { Svg } from '../../1_Atoms/Svg/Svg';
import ReactHtmlParser from 'react-html-parser';

interface JellyProps extends React.HTMLAttributes<HTMLDivElement> {
  topLabel?: string;
  carName?: string;
  carModel?: string;
  carPrice?: string | number;
  carImg?: string;
  carImgHover?: string;
  isInactive?: boolean;
  isSelected?: boolean;
  carImageSrc?: string;
  carImageHoverSrc?: string;
}

export const Jelly: React.FC<JellyProps> = ({
  topLabel = '',
  carName = '',
  carModel = '',
  carPrice = '',
  carImg = '',
  carImgHover = '',
  isInactive = false,
  isSelected = false,
  carImageSrc = '',
  carImageHoverSrc = '',
  ...otherProps
}) => {
  return (
    <div
      className={`mz-jelly ${isInactive ? 'inactive' : ''}`}
      {...otherProps}
    >
      <a className="mz-jelly__inner">
        {topLabel ? 
          <span className="mz-jelly-top">{topLabel}</span>:
          <span className="mz-jelly-top">&nbsp;</span>
        }
        {
          isSelected && (
            <div className="mz-jelly-select-icon">
              <Svg
                type="selected"
                size={1.75}
              />
            </div>
          )
        }
        <div className="mz-jelly-container">
          <Image
            className="mz-jelly-image"
            src={carImageSrc}
            alt={carName}
            isLazy={false}
          />
          <Image
            className="mz-jelly-image--hover"
            src={carImageHoverSrc}
            alt={carName}
            isLazy={false}
          />
        </div>

        <div className="mz-jelly-content">
          <h5>{ReactHtmlParser(carName)}</h5>
          <div className="mz-jelly-content__short-disc">{ReactHtmlParser(carModel)}</div>
        </div>
      </a>
    </div>
  );
};

export default Jelly;
